import { ComponentQuery } from 'models';

import { CaseStudySearchService } from 'components/case-study-search/services/CaseStudySearchService';
import { SearchService } from 'components/component-overview/services/SearchService';
import { ProfileOverviewService } from 'components/profile-overview/services/ProfileOverviewService';
import { SearchHistoryScope, useSearchHistory } from 'hooks/use-search-history';
import { DesignLibraryService } from 'services/DesignLibraryService';
import { InternalTrackingService } from 'services/InternalTrackingService';

type ApplySearchQueryOptions = {
    defaults?: Partial<ComponentQuery>;
    historyScope?: SearchHistoryScope;
    acrossSite?: boolean;
};

export const useApplySearchQuery = ({
    defaults,
    historyScope = SearchHistoryScope.GLOBAL,
    acrossSite = false,
}: ApplySearchQueryOptions = {}) => {
    const { addSearchHistory } = useSearchHistory(historyScope);

    return (text: string) => {
        const query = text.trim();
        const productFilters: Partial<ComponentQuery> = { search: text };

        if (query) {
            addSearchHistory(text);

            InternalTrackingService.track('product.search.query', {
                query: text,
                filters: { previous: SearchService.getCleanFilters(), calculated: { productFilters } },
            });
        }

        SearchService.resetFilters(defaults);

        if (query) {
            SearchService.mergeFilters(productFilters);
        }

        if (acrossSite) {
            ProfileOverviewService.resetFilters();
            DesignLibraryService.resetFilters();
            CaseStudySearchService.resetFilters();

            if (query) {
                ProfileOverviewService.mergeFilters({ search: text });
                DesignLibraryService.mergeFilters({ search: text });
                CaseStudySearchService.mergeFilters({ search: text });
            }
        }
    };
};
